"use strict";

function _interopRequireDefault(o) {
  return o && o.__esModule ? o : {
    default: o
  };
}
function _objectWithoutProperties(o, e) {
  var r = {};
  for (var t in o) e.indexOf(t) >= 0 || Object.prototype.hasOwnProperty.call(o, t) && (r[t] = o[t]);
  return r;
}
function make(o, e) {
  var r = e.left,
    t = e.right,
    p = e.up,
    l = e.down,
    u = e.top,
    a = e.bottom,
    i = e.big,
    n = e.mirror,
    s = e.opposite,
    d = (r ? 1 : 0) | (t ? 2 : 0) | (u || l ? 4 : 0) | (a || p ? 8 : 0) | (n ? 16 : 0) | (s ? 32 : 0) | (o ? 64 : 0) | (i ? 128 : 0);
  if (lookup.hasOwnProperty(d)) return lookup[d];
  var _ = r || t || p || l || u || a,
    f = void 0,
    b = void 0;
  if (_) {
    if (!n != !(o && s)) {
      var y = [t, r, a, u, l, p];
      r = y[0], t = y[1], u = y[2], a = y[3], p = y[4], l = y[5];
    }
    var m = i ? "2000px" : "100%";
    f = r ? "-" + m : t ? m : "0", b = l || u ? "-" + m : p || a ? m : "0";
  }
  return lookup[d] = (0, _globals.animation)((o ? "to" : "from") + " {" + (_ ? " transform: translate3d(" + f + ", " + b + ", 0);" : "") + "}\n     " + (o ? "from" : "to") + " {transform: none;} "), lookup[d];
}
function Slide() {
  var o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : _globals.defaults,
    e = o.children,
    r = (o.out, o.forever),
    t = o.timeout,
    p = o.duration,
    l = void 0 === p ? _globals.defaults.duration : p,
    u = o.delay,
    a = void 0 === u ? _globals.defaults.delay : u,
    i = o.count,
    n = void 0 === i ? _globals.defaults.count : i,
    s = _objectWithoutProperties(o, ["children", "out", "forever", "timeout", "duration", "delay", "count"]),
    d = {
      make: make,
      duration: void 0 === t ? l : t,
      delay: a,
      forever: r,
      count: n,
      style: {
        animationFillMode: "both"
      },
      reverse: s.left
    };
  return (0, _wrap2.default)(s, d, d, e);
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var _propTypes = require("prop-types"),
  _wrap = require("./wrap"),
  _wrap2 = _interopRequireDefault(_wrap),
  _globals = require("./globals"),
  propTypes = {
    out: _propTypes.bool,
    left: _propTypes.bool,
    right: _propTypes.bool,
    top: _propTypes.bool,
    bottom: _propTypes.bool,
    big: _propTypes.bool,
    mirror: _propTypes.bool,
    opposite: _propTypes.bool,
    duration: _propTypes.number,
    timeout: _propTypes.number,
    delay: _propTypes.number,
    count: _propTypes.number,
    forever: _propTypes.bool
  },
  lookup = {};
Slide.propTypes = propTypes, exports.default = Slide, module.exports = exports.default;